// === ALLSAVE - Ad Inspiration Library ===

export const brandLogos = [
  "HelloFresh", "Canva", "AG1", "ClickFunnels", "True Classic",
  "Ridge", "Paramount", "Pearmill", "VaynerMedia", "Lunar",
  "KlientBoost", "Dentsu", "Gymshark", "Athletic Greens", "Huel",
];

export const navLinks = [
  { name: "Features", href: "#features" },
  { name: "Use Cases", href: "#use-cases" },
  { name: "Pricing", href: "#pricing" },
];

// Target personas with specific benefits
export const personas = [
  {
    id: "agency",
    title: "Agences Ads",
    subtitle: "Gagnez des heures de recherche créative",
    description: "Centralisez l'inspiration de toute votre équipe. Présentez des moodboards clients en 2 clics.",
    benefits: [
      "Bibliothèque partagée entre tous les créatifs",
      "Boards clients prêts à présenter",
      "Plus besoin de chercher 'cette pub qu'on avait vue'",
    ],
    icon: "building",
    color: "from-blue-500/20 to-cyan-500/10",
    accentColor: "text-blue-400",
  },
  {
    id: "founder",
    title: "Solo Founders",
    subtitle: "Votre swipe file personnel",
    description: "Sauvegardez les meilleures pubs de vos concurrents. Inspirez-vous des meilleurs pour scaler.",
    benefits: [
      "Espionnez légalement vos concurrents",
      "Gardez les hooks qui convertissent",
      "Créez des briefs créatifs en 5 min",
    ],
    icon: "rocket",
    color: "from-purple-500/20 to-pink-500/10",
    accentColor: "text-purple-400",
  },
  {
    id: "developer",
    title: "Devs & Makers",
    subtitle: "Trouvez l'inspiration design",
    description: "Landing pages, UI patterns, copywriting... Tout ce dont vous avez besoin pour shipper.",
    benefits: [
      "Landing pages qui convertissent",
      "Patterns UI/UX éprouvés",
      "Copywriting qui fait cliquer",
    ],
    icon: "code",
    color: "from-emerald-500/20 to-teal-500/10",
    accentColor: "text-emerald-400",
  },
];

export const features = [
  {
    id: 1,
    tag: "Sauvegardez",
    title: "Capturez tout ce qui vous inspire.",
    description: "Ajoutez manuellement vos publicités, landing pages et UGC préférés. Stockez URLs, images et notes en un seul endroit.",
    bullets: ["Import manuel simple et rapide", "Métadonnées automatiques", "Notes et commentaires d'équipe"],
  },
  {
    id: 2,
    tag: "Organisez",
    title: "Votre bibliothèque, vos règles.",
    description: "Créez des boards, catégories et tags. Filtrez par plateforme, format ou niche. Retrouvez n'importe quel contenu en secondes.",
    bullets: ["Boards et catégories personnalisés", "Système de tags intelligent", "Filtres puissants"],
  },
  {
    id: 3,
    tag: "Collaborez",
    title: "Partagez avec votre équipe.",
    description: "Commentez les contenus, mentionnez vos collègues, créez des moodboards collaboratifs. Tout le monde sur la même page.",
    bullets: ["Commentaires avec horodatage", "Boards partagés", "Export pour clients"],
  },
];

export const howItWorks = [
  {
    step: 1,
    title: "Ajoutez du contenu",
    description: "Collez une URL ou uploadez une image. Ajoutez titre, tags et notes.",
  },
  {
    step: 2,
    title: "Organisez par boards",
    description: "Créez des collections thématiques. Tagguez par niche, format ou émotion.",
  },
  {
    step: 3,
    title: "Retrouvez en 2 secondes",
    description: "Filtrez, cherchez, parcourez. Votre inspiration toujours à portée de main.",
  },
  {
    step: 4,
    title: "Partagez & collaborez",
    description: "Commentez en équipe, créez des moodboards clients, exportez.",
  },
];

export const contentTypes = [
  {
    id: 1,
    title: "Facebook & Instagram Ads",
    description: "Vidéos, images, carrousels avec métadonnées.",
    icon: "megaphone",
    count: "Le plus populaire",
  },
  {
    id: 2,
    title: "Landing Pages",
    description: "Screenshots complets, liens permanents.",
    icon: "layout",
    count: "Indispensable",
  },
  {
    id: 3,
    title: "UGC & Reels",
    description: "TikToks, Reels, contenu créateur.",
    icon: "video",
    count: "Tendance",
  },
  {
    id: 4,
    title: "Email Creatives",
    description: "Campagnes email, newsletters.",
    icon: "mail",
    count: "Sous-estimé",
  },
];

export const testimonials = [
  {
    id: 1,
    quote: "AllSave a transformé notre workflow créatif. On passe de l'idée au brief en 10 minutes au lieu de 2 heures.",
    name: "Marie Laurent",
    title: "Directrice Créative @ AdScale",
    avatar: null,
  },
  {
    id: 2,
    quote: "J'utilise AllSave tous les jours pour mes clients e-commerce. C'est devenu indispensable.",
    name: "Thomas Dubois",
    title: "Consultant Ads Freelance",
    avatar: null,
  },
  {
    id: 3,
    quote: "Enfin un outil simple pour sauvegarder mes inspirations sans les perdre dans des bookmarks oubliés.",
    name: "Sophie Martin",
    title: "Indie Maker",
    avatar: null,
  },
];

export const pricingPlans = [
  {
    id: "free",
    name: "Free",
    price: "0€",
    period: "pour toujours",
    description: "Commencez à construire votre swipe file.",
    features: ["50 contenus sauvegardés", "3 boards", "Tags basiques", "Support communauté"],
    cta: "Commencer gratuitement",
    popular: false,
  },
  {
    id: "pro",
    name: "Pro",
    price: "19€",
    period: "/mois",
    description: "Pour les créatifs et freelances sérieux.",
    features: ["Contenus illimités", "Boards illimités", "Filtres avancés", "Commentaires d'équipe", "Export PDF", "Support prioritaire"],
    cta: "Essai gratuit 14 jours",
    popular: true,
  },
  {
    id: "team",
    name: "Team",
    price: "49€",
    period: "/mois",
    description: "Pour les agences et équipes créatives.",
    features: ["Tout dans Pro", "Membres illimités", "Workspaces partagés", "Présentations clients", "Accès API", "Support dédié"],
    cta: "Contacter les ventes",
    popular: false,
  },
];

export const faqItems = [
  {
    question: "Qu'est-ce que je peux sauvegarder avec AllSave ?",
    answer: "Vous pouvez sauvegarder des publicités (Facebook, Instagram, TikTok, LinkedIn), des landing pages, du contenu UGC, des emails marketing, et tout visuel qui vous inspire.",
  },
  {
    question: "Comment ajouter du contenu ?",
    answer: "Utilisez le bouton 'Ajouter' dans votre dashboard. Collez l'URL ou uploadez une image, ajoutez un titre, des tags et vos notes. Simple et rapide.",
  },
  {
    question: "Puis-je partager mes boards avec des clients ?",
    answer: "Oui ! Créez des liens de partage publics pour n'importe quel board. Parfait pour les briefs créatifs et les moodboards clients.",
  },
  {
    question: "Y a-t-il un plan gratuit ?",
    answer: "Oui ! Le plan gratuit inclut 50 contenus sauvegardés et 3 boards. Aucune carte bancaire requise.",
  },
  {
    question: "Mon équipe peut-elle collaborer ?",
    answer: "Absolument. Avec le plan Team, vous avez des membres illimités, des workspaces partagés et des commentaires collaboratifs.",
  },
];

export const footerLinks = {
  product: [
    { name: "Fonctionnalités", href: "#features" },
    { name: "Use Cases", href: "#use-cases" },
    { name: "Pricing", href: "#pricing" },
  ],
  resources: [
    { name: "Blog", href: "#" },
    { name: "Help Center", href: "#" },
    { name: "Changelog", href: "#" },
  ],
  company: [
    { name: "À propos", href: "#" },
    { name: "Contact", href: "#" },
    { name: "Mentions légales", href: "#" },
  ],
};

// Sample content for previews
export const sampleContent = [
  { title: "Nike - Just Do It", type: "ad", platform: "Facebook", color: "#ef4444" },
  { title: "Stripe Landing Page", type: "landing_page", platform: "Web", color: "#6366f1" },
  { title: "UGC Review AG1", type: "ugc", platform: "TikTok", color: "#22c55e" },
  { title: "Notion Email Campaign", type: "email", platform: "Email", color: "#f59e0b" },
  { title: "Shopify Carousel Ad", type: "ad", platform: "Instagram", color: "#ec4899" },
  { title: "Linear Homepage", type: "landing_page", platform: "Web", color: "#3b82f6" },
];
